
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Panel from 'vux/src/components/panel/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {get,post} from '../api'
export default {
name:'BusinessMgr',
components: {
Tabbar,
TabbarItem,
Panel,
XHeader,
Toast
},
mounted() {
if(this.GLOBAL.currentUser==undefined){
this.$router.push({ path: '/' });
}
post('/Business/query', {}).then(response => {

this.businessInfo.splice(0, this.businessInfo.length);
this.businessDatas.splice(0, this.businessDatas.length);
if(response.code==1){
let index=0;
response.data.forEach(element => {
let picUrl=this.GLOBAL.auditCheckUrl;
if(element.Status==0){
picUrl=this.GLOBAL.auditNoUrl;
}
else if(element.Status==1){
picUrl=this.GLOBAL.auditPassUrl;
}

this.businessInfo.push({
src: picUrl,
title: element.BusinessName,
desc: '联系人:'+element.Contactor+';联系电话:'+element.TelNo+';详细地址:'+element.BusinessAddress+'。',
url: '/BusinessDetail?id='+index+'&tag=M'
});
index++;
});
this.businessDatas=response.data;
}
else if(response.code==0){
this.showError=true;
}
else if(response.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error => {
this.businessInfo.splice(0, this.businessInfo.length);
this.businessDatas.splice(0, this.businessDatas.length);
console.log(error);
});
},
methods: {
onImgError (item, $event) {
console.log(item, $event)
},
onClickItem(item){


this.GLOBAL.currentObjs=this.businessDatas;
}
},
data () {
return {
type: '5',
businessInfo: [],
businessDatas:[],
footer: {
title: "",
url: ''
},
showSuccess:false,
showWarn:false,
showError:false,
SuccessInfo:'查询成功!',
WarnInfo:'',
ErrorInfo:'系统异常,联系管理员!',
}
}
}



// WEBPACK FOOTER //
// ./src/components/ManagerModules/BusinessMgr.vue